/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Pit1_DInputs */

const en_to_typescript_pit1_d = /** @type {(inputs: To_Typescript_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionality is derived by comparing objects within an array. Paste one object and you get an interface where nothing is optional, which will typecheck against your sample and then fail at runtime the first time the API omits a field. Paste an array with at least one sparse record, or add the question marks yourself.`)
};

const ko_to_typescript_pit1_d = /** @type {(inputs: To_Typescript_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택성은 배열 안의 객체들을 비교해서 도출됩니다. 객체 하나를 붙여넣으면 아무것도 선택적이지 않은 인터페이스가 나오는데, 이는 샘플에 대해서는 타입 검사를 통과하고 API가 필드를 처음 생략하는 순간 런타임에 실패합니다. 최소 하나의 빈약한 레코드를 포함한 배열을 붙여넣거나, 물음표를 직접 추가하세요.`)
};

const ja_to_typescript_pit1_d = /** @type {(inputs: To_Typescript_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意性は配列内のオブジェクトを比べて導かれます。オブジェクト 1 つを貼り付けると何も任意でないインターフェースが出ますが、それはサンプルに対しては型チェックを通り、API が初めてフィールドを省いた瞬間に実行時に失敗します。中身の乏しいレコードを少なくとも 1 件含む配列を貼り付けるか、疑問符を自分で付けてください。`)
};

/**
* | output |
* | --- |
* | "Optionality is derived by comparing objects within an array. Paste one object and you get an interface where nothing is optional, which will typecheck agains..." |
*
* @param {To_Typescript_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_pit1_d = /** @type {((inputs?: To_Typescript_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_pit1_d(inputs)
	if (locale === "ko") return ko_to_typescript_pit1_d(inputs)
	return ja_to_typescript_pit1_d(inputs)
});